<template>
  <div>
    <div class="klickbox-step-content">
      <div v-html="quizInternalStyle"></div>
      <top-message :step="stepActive"></top-message>
      <config></config>
      <step-title :step="stepActive"></step-title>
      <step-description :step="stepActive"></step-description>
      <multiple-choice
        v-if="stepActive.kind === 'multiple-choice' || stepActive.kind === 'yes-no'"
        :step="stepActive">
      </multiple-choice>
      <text-step
        v-if="stepActive.kind === 'text'"
        :step="stepActive">
      </text-step>
      <email
        v-if="stepActive.kind === 'email'"
        :step="stepActive">
      </email>
      <redirect
        v-if="stepActive.kind === 'redirect'"
        :step="stepActive">
      </redirect>
      <welcome
        v-if="stepActive.kind === 'welcome'"
        :step="stepActive">
      </welcome>
      <step-next-button
        v-if="(stepActive.kind === 'multiple-choice' && stepActive.multiple_answers) || stepActive.kind === 'text'"
        :step="stepActive">
      </step-next-button>
    </div>
    <a class="flow_button" @click="canvasChangeView('fluxogram');"><i class="fa fa-sitemap"></i>{{ $t('edit.canvas.see_flow') }}</a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MultipleChoice from './kind/MultipleChoice.vue';
import TextStep from './kind/Text.vue';
import Email from './kind/Email.vue';
import Redirect from './kind/Redirect.vue';
import Welcome from './kind/Welcome.vue';
import TopMessage from './TopMessage.vue';
import StepTitle from './Title.vue';
import StepDescription from './Description.vue';
import StepNextButton from './NextButton.vue';
import Config from './config/Main.vue';

export default {
  components: {
    MultipleChoice,
    TextStep,
    Email,
    Redirect,
    Welcome,
    TopMessage,
    StepTitle,
    StepDescription,
    StepNextButton,
    Config,
  },
  computed: mapGetters({
    stepActive: 'stepActive',
    quizInternalStyle: 'quizInternalStyle',
  }),
  methods: mapActions([
    'canvasChangeView',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?89c1bfe2
 **/